import { useTranslation } from 'react-i18next';

export function SubListItemEmpty() {
  const { t } = useTranslation();
  return (
    <div className="w-96 text-center justify-start text-neutrals-N700 text-sm font-normal leading-tight">
      {t('domain.navigation.benachrichtigungen.empty')}
    </div>
  );
}
